export const SponserQueryKeys = {
  all: ['package'] as const,
  lists: () => [...SponserQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...SponserQueryKeys.lists(), filters] as const,
  details: () => [...SponserQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...SponserQueryKeys.details(), id] as const,
};
